import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiDeleteDocumentState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiDeleteDocumentState = { state: 'pending' };

export const ciDeleteDocumentReducer = createReducer(
    initialState,
    on(identityCardActions.deleteDocument, (state) => ({ ...state, state: 'loading' as const })),
    on(identityCardActions.deleteDocumentSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(identityCardActions.deleteDocumentFail, (state) => ({ ...state, state: 'error' as const })),
    on(identityCardActions.clearDeleteDocument, () => initialState)
);
